import React, { useState } from "react";
import Hallticket from "../components/Hallticket/Hallticket";
import Aside from "../modules/SideNav/Aside";

const HallticketLayout = () => {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Hallticket />
    </div>
  );
};

export default HallticketLayout;
